import { TextField} from '@fluentui/react';
import React, { useEffect, useState } from "react";
import Warning from '../../CreateSite/CommonComponents/Warning';
import validator from 'validator';

const CustomTextField = ({defaultValue, value, onUpdate, disabled, isreadonly, multiline, onValidation, required, validationFormat, errorMessage, warningMessage, onBlur, additionalIcon}) => {

    const [newValue, setNewValue] = useState(defaultValue)
    const [error, setError] = useState()
    const [isValid, setIsValid] = useState(true)

    useEffect(() => {
        if (onValidation) 
            onValidation(isValid)
    }, [isValid])

    useEffect(() => {
        if (value !== undefined)
            setNewValue(value)
    }, [value])

    useEffect(() => {
        validate()
    }, [newValue, validationFormat, required])

    const validate = () => {
        if (required) {
            setError('Field cannot be empty.')
            if (setValueValid(!!newValue))
                return
        }

        if (newValue) {
            switch (validationFormat)
            {
                case 'url':
                    setError('Value must be in URL format.')
                    if (setValueValid(validator.isURL(newValue)))
                        return
                    break;
                case 'email':
                    setError('Value must be in e-mail format.')
                    if (setValueValid(validator.isEmail(newValue)))
                        return
                    break;
                default:
                    break;
            }
        }

        setIsValid(true)
    }

    const setValueValid = (isValidValue) => {
        setIsValid(isValidValue)
        return !isValidValue
    }
    
    const onChange = (e, v) => {
        setNewValue(v)
        if (onUpdate)
            onUpdate(v)
    }

    const warning = !isValid
                    ? <Warning element='nolabel-small' title={error} />
                    : null;

    return (
        <div style={{width:'100%', position:'relative'}}>
            <div>
                <TextField
                    value={newValue}
                    onChange={onChange}
                    disabled={disabled || isreadonly}
                    multiline={multiline}
                    errorMessage={errorMessage}
                    onBlur={onBlur}
                />
                {warning}
                <div className='absoluteIcon warning-nolabel-small'>
                    {additionalIcon}
                </div>            
                {
                    !errorMessage && warningMessage &&
                    <div className='warningMessage'>
                        { warningMessage }
                    </div> 
                }
            </div>
        </div>
    );
}

export default CustomTextField


// WEBPACK FOOTER //
// ./src/components/EditSite/SiteEditElements/CustomTextField.js